// putting it here avoids infinite dependency issues
/** @type {(vhType: import("@core/models/virtualhuman.types").VHType) => boolean} */
export const GetServerCompletesSession = function (vhType) {
  return vhType === 'freeform_v3';
};
